import React from 'react';
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Footer from './components/layout/Footer';
import Navigation from './components/layout/Navigation';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import Home from './pages/Home';
import OrderSummary from './pages/OrderSummary';
import Product from './pages/Product';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './utils/NotFound';
import WishList from './pages/WishList';
import "react-toastify/dist/ReactToastify.css";
import FilterByNav from './pages/FilterByNav';
import Auth from './pages/Auth';
import PrivateRoute from './components/auth/PrivateRoute';
import User from './pages/user';
import OrderSuccessSummary from './pages/OrderSuccessSummary';
import OrderFailSummary from './pages/OrderFailSummary';
import TrackOrder from './pages/TrackOrder';
import Knowledge from './pages/knowledge';


function App() {

  return (
    <div className='my-app'>
      <ToastContainer />
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nav-filter/:navs" element={<FilterByNav />} />
        <Route path="/products/:productId" element={<Product />} />
        <Route path="/carts" element={<Cart />} />
        <Route path="/checkout" element={
          <PrivateRoute>
            <Checkout />
          </PrivateRoute>
        } />
        <Route path="/wishlist" element={<WishList />} />
        <Route path="/order/summary" element={<OrderSummary />} />
        <Route path="/order/ssl-success/:tranId" element={<OrderSuccessSummary />} />
        <Route path="/order/track-your-order/:id" element={
          <PrivateRoute>
            <TrackOrder />
          </PrivateRoute>
        } />
        <Route path="/order/ssl-fail" element={<OrderFailSummary />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="auth/*" element={<Auth />} />
        <Route path="user/*" element={
          <PrivateRoute>
            <User />
          </PrivateRoute>
        } />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="knowledge/*" element={<Knowledge />} />
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
